import {useEffect} from "react";
import {usePage} from "@inertiajs/react";

export default function usePageChangesForYaMetrica() {
    const {url} = usePage();

    useEffect(() => {
        let attempts = 0;
        // Максимальное количество попыток
        const maxAttempts = 150;
        const intervalId = setInterval(() => {
            attempts++;
            if (typeof ym === "function" || attempts >= maxAttempts) {
                // Остановить вызов каждую секунду
                clearInterval(intervalId);
                if (typeof ym === "function") {
                    // Вызвать функцию ym
                    ym(45198306, 'hit', location.href);
                } else {
                    // Если ym так и не стало доступной
                    console.log("ym is not available");
                }
            }
        }, 100);
    }, [url]);
}
